<template>
  <div :class="{'active':active}">
    <router-link v-if="to" :to="to" :class="['button',mode ,type]" >
      <span>{{ label }}</span>
    </router-link>
    <button v-else :class="['button',mode, type]">
      <span>{{ label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Mbutton",
  props: {
    type:{
      type:String,
      default:"success"
    },
    active: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "مشاهده"
    },
    to: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: "btn-3"
    }
  }
}
</script>

<style lang="stylus">
.active
  .button
    background-color var(--green) !important
    span
      color var(--white) !important
.button
  position relative
  display inline-block
  font-size 16px
  font-family var(--font-medium)
  cursor pointer
  padding 0 10px
  height 35px
  &.success
    border 1px solid var(--green)
    background transparent
    color var(--cyan)
    &:hover
      color var(--green)
  &.danger
    border 1px solid var(--red)
    background transparent
    color var(--orange)
    &:hover
      color var(--orange)

  &:focus
    outline none
  span
    display block
    line-height: 32px;
    &::before, &::after
      position absolute
      width 1px
      height 0
      background var(--cyan)
      content ''
      transition all 0.2s linear
.button::before, .button::after
  position absolute
  width 0
  height 1px
  background var(--cyan)
  content ''
  transition all 0.2s linear
.button:hover::before, .button:hover::after
  width 100%
.button:hover span::before, .button:hover span::after
  height 100%
/* ----- .button 1 ----- */
.btn-1::before, .btn-1::after
  transition-delay 0.2s
.btn-1 span::before, .btn-1 span::after
  transition-delay 0s
.btn-1::before
  top 0
  right 0
.btn-1::after
  bottom 0
  left 0
.btn-1 span::before
  top 0
  left 0
.btn-1 span::after
  right 0
  bottom 0
.btn-1:hover::before, .btn-1:hover::after
  transition-delay 0s
.btn-1:hover span::before, .btn-1:hover span::after
  transition-delay 0.2s
/* --- Button 2 ------- */
.btn-2::before, .btn-2::after
  transition-delay 0s
.btn-2 span::before, .btn-2 span::after
  transition-delay 0.2s
.btn-2::before
  top 0
  right 0
.btn-2::after
  bottom 0
  left 0
.btn-2 span::before
  top 0
  left 0
.btn-2 span::after
  right 0
  bottom 0
.btn-2:hover::before, .btn-2:hover::after
  transition-delay 0.2s
.btn-2:hover span::before, .btn-2:hover span::after
  transition-delay 0s
/* ----- button 3 ----- */
.btn-3::after
  bottom 0
  left 0
  transition-delay 0.6s
.btn-3 span::after
  right 0
  bottom 0
  transition-delay 0.4s
.btn-3::before
  top 0
  right 0
  transition-delay 0.2s
.btn-3 span::before
  top 0
  left 0
  transition-delay 0s
.btn-3:hover::after
  transition-delay 0s
.btn-3:hover span::after
  transition-delay 0.2s
.btn-3:hover::before
  transition-delay 0.4s
.btn-3:hover span::before
  transition-delay 0.6s
/* ----- button 4 ----- */
.btn-4::after
  right 0
  bottom 0
  transition-duration 0.4s
.btn-4 span::after
  right 0
  bottom 0
  transition-duration 0.4s
.btn-4::before
  top 0
  left 0
  transition-duration 0.4s
.btn-4 span::before
  top 0
  left 0
  transition-duration 0.4s
/* ----- button 5 ----- */
.btn-5::after
  bottom 0
  left 0
  transition-duration 0.4s
.btn-5 span::after
  top 0
  right 0
  transition-duration 0.4s
.btn-5::before
  top 0
  right 0
  transition-duration 0.4s
.btn-5 span::before
  bottom 0
  left 0
  transition-duration 0.4s
/* ----- button 6 ----- */
.btn-6::before
  top 0
  left 50%
  transition-duration 0.4s
.btn-6::after
  bottom 0
  left 50%
  transition-duration 0.4s
.btn-6 span::before
  top 50%
  left 0
  transition-duration 0.4s
.btn-6 span::after
  top 50%
  right 0
  transition-duration 0.4s
.btn-6:hover::before, .btn-6:hover::after
  left 0
.btn-6:hover span::before, .btn-6:hover span::after
  top 0
</style>



// WEBPACK FOOTER //
// src/components/element/button/index.vue